import { z } from 'zod';
import { ErrorResponseSchema } from './errors';

// ============================================================================
// PRINT PDF SCHEMAS
// ============================================================================

// Result payload for creating a print PDF
export const CreatePrintPdfResultSchema = z.object({
  signedUrl: z.string(),
});
export type CreatePrintPdfResult = z.infer<typeof CreatePrintPdfResultSchema>;

// ============================================================================
// PRINT PDF API RESPONSE SCHEMAS
// ============================================================================

// Success response schema
export const CreatePrintPdfSuccessResponseSchema = z.object({
  type: z.literal('success'),
  data: CreatePrintPdfResultSchema,
});

// Discriminated union response
export const CreatePrintPdfResponseSchema = z.discriminatedUnion('type', [
  CreatePrintPdfSuccessResponseSchema,
  ErrorResponseSchema,
]);

// ============================================================================
// PRINT PDF TYPE EXPORTS
// ============================================================================

export type CreatePrintPdfResponse = z.infer<
  typeof CreatePrintPdfResponseSchema
>;
